<template>
  <!-- <footer class="footer" :class="{ invert: invert }"> -->
  <footer :class="{ invert: invert }">
    <v-container class="max-lg mt-10 pt-10 pb-5">
      <div class="d-flex justify-space-between pb-2 white--text" v-if="$vuetify.breakpoint.smAndUp">
        <div>
          <span style="padding: 8px 12px 8px 12px">
            &copy;&nbsp; {{ new Date().getFullYear() }} Pintek OÜ
          </span>
          |
          <a href="tel:+37256570441" class="link white--text">
            <small>+372</small>
            56 570 441
          </a>
          |
          <a href="mailto:bookus@bookus.live" class="link white--text">bookus@bookus.live</a>
        </div>

        <div>
          <span>
            <a
              href="/terms"
              class="link white--text text--muted"
              @click.prevent="$router.push('terms')"
            >
              <span v-t="'Terms'" />
            </a>
          </span>
          <span>
            <a
              href="/privacy"
              class="link white--text text--muted"
              @click.prevent="$router.push('privacy')"
            >
              <span v-t="'Privacy policy'" />
            </a>
          </span>
        </div>
      </div>
      <div class="pb-2 white--text" v-else>
        <div class="my-1">&copy;&nbsp; {{ new Date().getFullYear() }} Pintek OÜ</div>
        <div class="my-1">
          <a href="tel:+37256570441" class="link white--text">
            <span>(+372)</span>
            56 570 441
          </a>
        </div>
        <div class="my-1">
          <a href="mailto:bookus@bookus.live" class="link white--text">bookus@bookus.live</a>
        </div>
        <div class="my-1">
          <a
            href="/terms"
            class="link white--text text--muted"
            @click.prevent="$router.push('terms')"
          >
            <span v-t="'Terms'" />
          </a>
        </div>
        <div class="my-1">
          <a
            href="/privacy"
            class="link white--text text--muted"
            @click.prevent="$router.push('privacy')"
          >
            <span v-t="'Privacy policy'" />
          </a>
        </div>
      </div>
      <!-- <v-row class="spacing4">
        <v-col class="pa-4" md="3" cols="12">
          <div class="logo">
            <img :src="logo" alt="B" />
            <h6 class="title">
              {{ brand.projectName }}
            </h6>
          </div>
          <p class="body-2 text-center" v-if="isDesktop">
            &copy;&nbsp;
            {{ brand.footerText }}
          </p>
        </v-col>
      </v-row> -->
      <!-- <p class="body-2 text-center" v-if="isMobile">
        &copy;&nbsp;
        {{ brand.footerText }}
      </p> -->
    </v-container>
  </footer>
</template>

<style scoped lang="scss">
@import "./footer-style";
</style>

<script>
import logo from "@/landing/static/logo.svg";
import brand from "@/landing/static/text/brand";

export default {
  data: () => ({
    logo: logo,
    brand: brand,
    lang: "en",
    footers: [
      {
        title: "Company",
        description: ["Team", "History", "Contact us", "Locations"],
        link: ["#team", "#history", "#contact-us", "#locations"],
      },
      {
        title: "Resources",
        description: ["Resource", "Resource name", "Another resource", "Final resource"],
        link: ["#resource", "#resource-name", "#another-resource", "#final-resource"],
      },
      {
        title: "Legal",
        description: ["Privacy policy", "Terms of use", "Data deletion"],
        link: ["privacy", "terms", "data-deletion"],
      },
    ],
  }),
  props: {
    invert: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isDesktop() {
      return this.$vuetify.breakpoint.mdAndUp;

      //   const mdUp = this.$store.state.breakpoints.mdUp
      //   return mdUp.indexOf(this.$mq) > -1
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;

      //   const smDown = this.$store.state.breakpoints.smDown
      //   return smDown.indexOf(this.$mq) > -1
    },
    langList: function () {
      const list = [
        { text: "Eesti keel", value: "et" },
        { text: "English", value: "en" },
      ];
      //   this.$i18n.locales.map((item) => {
      //     list.push({ text: this.$t("common." + item.code), value: item.code });
      //   });
      return list;
    },
  },
  mounted() {
    // this.lang = this.$i18n.locale;
  },
  methods: {
    switchLang: function (val) {
      this.$i18n.setLocale(val);
    },
  },
};
</script>
